import { CSSObject } from '@emotion/react'
import { fonts, fontSizes } from '@opallabs/pulsar'
import { colors } from '@opallabs/spectrum'
import { sharedColors } from './colors'

const getAccountUsername = (isStream: boolean): CSSObject => ({
  color: sharedColors.medGreyText,
  display: 'block',
  margin: isStream ? '0 4px 0 0' : '4px 0 0 8px',
  zIndex: 1,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
})

const getRetweetWrapper = (isStream: boolean): CSSObject => ({
  margin: isStream ? '0 16px 0 75px' : '0 16px 0 16px',
})

const getScheduledTimeText = (addPadding: boolean): CSSObject => ({
  padding: addPadding ? '0 0 0 4px' : '0',
  color: sharedColors.medGreyText,
  fontSize: fontSizes.large,
  fontFamily: fonts.proxima,
})

const scheduledTimeWrapper: CSSObject = {
  marginTop: '-3px',
}

const flexColumn: CSSObject = {
  display: 'flex',
  flexDirection: 'column',
}

const flexRow: CSSObject = {
  display: 'flex',
  flexDirection: 'row',
}

const displayInline: CSSObject = {
  display: 'inline-block',
}

const getTwitterCaretWrapper = (isMobileStream: boolean): CSSObject => ({
  marginTop: isMobileStream ? 0 : '4px',
  color: colors.n6.base,
})

const sharedStyles = {
  getAccountUsername,
  getRetweetWrapper,
  getScheduledTimeText,
  scheduledTimeWrapper,
  flexColumn,
  flexRow,
  displayInline,
  getTwitterCaretWrapper,
}

export { sharedColors, sharedStyles }
